import { render, staticRenderFns } from "./Spending.vue?vue&type=template&id=5b52b750&"
import script from "./Spending.vue?vue&type=script&lang=js&"
export * from "./Spending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports